import React, { useState } from "react";
import { toast } from "react-toastify";

const Profile = () => {
  const [role, setRole] = useState("");

  const admin = JSON.parse(window.localStorage.getItem("admin"));

  const handleRole = (event) => {
    setRole(event.target.value);
  };

  const handleEditAdmin = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    object.role = role;
    object.admin = admin?._id;

    const response = null;
    if (response) {
      toast.success("Admin update successfully!");
      window.localStorage.setItem("admin", JSON.stringify(response));
      window.location.reload();
    }
  };

  return (
    <div className="container">
      <div className="overview">
        <div className="title">
          <ion-icon name="help-circle-outline"></ion-icon>
          <span className="text">Profile</span>
        </div>
      </div>

      <form onSubmit={handleEditAdmin}>
        <div className="mb-3">
          <label htmlFor="recipient-name" className="col-form-label">
            Name
          </label>
          <input
            type="text"
            className="form-control truncate"
            id="recipient-name"
            placeholder="Name"
            name="name"
            defaultValue={admin?.name}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="recipient-name" className="col-form-label">
            Email
          </label>
          <input
            type="text"
            className="form-control truncate"
            id="recipient-name"
            placeholder="Email"
            name="email"
            defaultValue={admin?.email}
          />
        </div>
        <div className="mb-3">
          <label for="recipient-name" className="col-form-label">
            Phone Number
          </label>

          <input
            type="text"
            className="form-control truncate"
            id="recipient-name"
            placeholder="Phone Number"
            name="phoneNumber"
            defaultValue={admin?.phoneNumber}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="recipient-name" className="col-form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control truncate"
            id="recipient-name"
            placeholder="Password"
            name="password"
            // defaultValue={admin.admin?.password}
          />
        </div>
        <div className="">
          <label htmlFor="recipient-name" className="col-form-label">
            Role
          </label>
          <div className="role">
            <select
              className="form-select "
              aria-label="Default select example"
              onChange={handleRole}
              defaultValue={admin?.role}
            >
              <option value="Admin">Admin</option>
              <option value="Super Admin">Super Admin</option>
            </select>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button id="update-profile" className="btn-header">
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default Profile;
